import * as React from "react";
import { hot } from "react-hot-loader";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Candidatures from '../../components/Candidatures/Candidatures';
import Footer from '../../components/Footer/Footer';
import FormulaireCandidature from '../../components/FormulaireCandidature/FormulaireCandidature';
import Header from '../../components/Header/Header';
import Home from '../../components/Home/Home';
import Inscription from '../../components/Inscription/Inscription';
import InscriptionActivation from '../../components/Inscription/InscriptionActivation/InscriptionActivation';
import MdpPerdu from '../../components/MdpPerdu/MdpPerdu';
import MdpPerduRenouvellement from '../../components/MdpPerdu/MdpPerduRenouvellement/MdpPerduRenouvellement';
declare var configcustoms: any;


class CustomRouter extends React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
    }

    public render() {

        return (
            <Router>
                <div id="main-router">
                    <Header />
                    <div className="container pt-5 pb-4 router-container">
                        <Switch>
                            <Redirect from={configcustoms.Route.StartedRoute} to={configcustoms.Route.Home} />
                            <Route path={configcustoms.Route.Formulaire} component={FormulaireCandidature} />
                            <Route path={configcustoms.Route.Home} exact={true} component={Home} />
                            <Route path={configcustoms.Route.Inscription} component={Inscription} />
                            <Route path={configcustoms.Route.InscriptionActivation} component={InscriptionActivation} />
                            <Route path={configcustoms.Route.MdpPerdu} component={MdpPerdu} />
                            <Route path={configcustoms.Route.MdpPerduRenouvellement} component={MdpPerduRenouvellement} />
                            <Route path={configcustoms.Route.Candidatures} component={Candidatures} />
                        </Switch>
                    </div>                
                    <Footer />
                </div>
            </Router>
        );
    }
}

export default hot(module)(CustomRouter);
